import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import resize from '@/mixins/resize';
import * as echarts from 'echarts';
import moment from 'moment';
let myChart0 = null;
let myChart1 = null;
let myChart2 = null;
let myChart3 = null;
let myChart4 = null;
import { mapState } from 'vuex';
export default {
  name: 'groupBar',
  mixins: [resize],
  props: ['panelData', 'itemNum'],
  data() {
    return {
      sourceX: ['2016', '2017', '2018', '2019'],
      source: [{
        name: '保险1',
        data: [1500, 2800, 3500, 2900]
      }, {
        name: '保险2',
        data: [700, 600, 550, 420]
      }, {
        name: '保险3',
        data: [1600, 2300, 2800, 3300]
      }, {
        name: '保险4',
        data: [1600, 2800, 3500, 2000]
      }]
    };
  },
  computed: {
    ...mapState({
      locale: state => state.setting.locale
    })
  },
  mounted() {
    this.$nextTick(() => {
      if (this.itemNum == 0) {
        myChart0 = echarts.init(this.$refs.groupBar);
      } else if (this.itemNum == 1) {
        myChart1 = echarts.init(this.$refs.groupBar);
      } else if (this.itemNum == 2) {
        myChart2 = echarts.init(this.$refs.groupBar);
      } else if (this.itemNum == 3) {
        myChart3 = echarts.init(this.$refs.groupBar);
      } else if (this.itemNum == 4) {
        myChart4 = echarts.init(this.$refs.groupBar);
      }
      this.initEchart();
    });
  },
  beforeDestroy() {
    if (this.itemNum == 0) {
      myChart0 && myChart0.clear();
    } else if (this.itemNum == 1) {
      myChart1 && myChart1.clear();
    } else if (this.itemNum == 2) {
      myChart2 && myChart2.clear();
    } else if (this.itemNum == 3) {
      myChart3 && myChart3.clear();
    } else if (this.itemNum == 4) {
      myChart4 && myChart4.clear();
    }
  },
  watch: {
    locale: {
      handler() {
        this.$nextTick(() => {
          this.initEchart();
        });
      }
    },
    panelData: {
      handler(newArr) {
        if (this.itemNum == 0) {
          myChart0 && myChart0.clear();
          myChart0 = echarts.init(this.$refs.groupBar);
        } else if (this.itemNum == 1) {
          myChart1 && myChart1.clear();
          myChart1 = echarts.init(this.$refs.groupBar);
        } else if (this.itemNum == 2) {
          myChart2 && myChart2.clear();
          myChart2 = echarts.init(this.$refs.groupBar);
        } else if (this.itemNum == 3) {
          myChart3 && myChart3.clear();
          myChart3 = echarts.init(this.$refs.groupBar);
        } else if (this.itemNum == 4) {
          myChart4 && myChart4.clear();
          myChart4 = echarts.init(this.$refs.groupBar);
        }
        this.$nextTick(() => {
          this.initEchart();
        });
      }
    },
    deep: true
  },
  methods: {
    initEchart() {
      if (this.panelData) {
        this.sourceX = this.panelData.sourceX.map(item => {
          return moment(item, 'YYYY-MM-DD', true).isValid() ? moment(item).format(this.getFormatDate()) : item;
        });
        this.source = this.panelData.source;
      }
      let series = [];
      this.source.map((item, index) => {
        let obj = {
          name: this.$t(item.name),
          type: 'bar',
          stack: 'PC',
          data: item.data,
          barWidth: '10',
          barGap: '20%',
          type: 'bar'
        };
        series.push(obj);
      });
      let that = this;
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          padding: [2, 10],
          formatter: function (params) {
            if (params instanceof Array) {
              let str = '',
                arr = [];
              str += `${params[0].axisValue}<br/>`;
              params.forEach((m, index) => {
                if (m.data != 0) {
                  arr.push(m);
                }
              });
              if (arr.length == 0) {
                str += that.$t('暂无数据');
              } else {
                let num = 550;
                if (arr.length == 1) {
                  num = 275;
                }
                str += `<div style="display:flex;flex-wrap: wrap;width:${num}px">`;
                arr.forEach((m, index) => {
                  str += `
                     <div style="display: flex;width:275px;align-items:baseline;font-size:10px">
                       <div style="width: 8px;height: 8px;display: inline-block;background: ${m.color};border-radius: 10px;margin-right: 5px;margin-left: 5px; "></div>
                       <div style="display:flex;align-items: baseline;flex:1;overflow: hidden;margin-right: 5px;">
                        <div style="max-width: 100%;
                          word-break: break-all;
                          text-overflow: ellipsis;
                          white-space:pre-wrap;
                          overflow: hidden;
                          display: -webkit-box;
                          -webkit-box-orient: vertical;
                          -webkit-line-clamp: 2;">${m.seriesName}:<span> ${m.data}</span></div></div>
                     </div>
                     `;
                });
                str += `</div>`;
              }
              return str;
            }
          },
          position: function (point, params, dom, rect, size) {
            //其中point为当前鼠标的位置，
            //size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
            // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
            // 提示框位置
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置
            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];
            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];
            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = 5;
            } else {
              // 左边放的下
              x = pointX - boxWidth;
            }
            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else {
              // 上边放得下
              y = pointY - boxHeight;
            }
            return [x, y];
          }
        },
        grid: {
          left: 80,
          right: 20,
          bottom: 50,
          top: 70
        },
        legend: {
          show: true,
          type: 'scroll',
          formatter: name => {
            return this.$t(name);
          }
        },
        xAxis: [{
          type: 'category',
          data: that.sourceX,
          axisLine: {
            lineStyle: {
              color: '#cecece'
            }
          },
          axisLabel: {
            color: '#666'
          },
          axisTick: {
            show: false
          }
        }],
        yAxis: [{
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#cecece'
            }
          },
          axisLabel: {
            color: '#666'
          },
          splitLine: {
            show: false
          }
        }],
        series: series
      };
      if (this.itemNum == 0) {
        myChart0.setOption(option, true);
      } else if (this.itemNum == 1) {
        myChart1.setOption(option, true);
      } else if (this.itemNum == 2) {
        myChart2.setOption(option, true);
      } else if (this.itemNum == 3) {
        myChart3.setOption(option, true);
      } else if (this.itemNum == 4) {
        myChart4.setOption(option, true);
      }
    }
  }
};